import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { id: "footer" };
const _hoisted_2 = { class: "inner" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("small", null, "Copyright © sharementors All rights reserved .", -1);
const _hoisted_4 = {
    id: "page-top",
    class: "pc"
};
const _hoisted_5 = { href: "#" };
import { onMounted, nextTick } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import ImageFrame from '@component/ImageFrame.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'footer',
    setup(__props) {
        const lincs = [
            { label: '利用規約', href: route('terms') },
            { label: 'プライバシーポリシー', href: route('policy') },
            { label: '特定商取引法に基づく表記', href: route('law') },
            { label: 'お問合せ', href: route('inquiry.create') },
            { label: '運営会社', href: route('about') },
        ];
        onMounted(() => {
            nextTick(() => {
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('./footer-jquery');
                if (key)
                    delete require.cache[key];
                require('./footer-jquery');
                var key = require.resolve('@jquery/page-anim');
                if (key)
                    delete require.cache[key];
                require('@jquery/page-anim');
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("footer", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("ul", null, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(lincs, (link) => {
                                return _createElementVNode("li", null, [
                                    _createVNode(_unref(Link), {
                                        href: link.href
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(link.label), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["href"])
                                ]);
                            }), 64))
                        ])
                    ]),
                    _hoisted_3
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("a", _hoisted_5, [
                        _createVNode(ImageFrame, {
                            src: "images/common/bt_pagetop.svg",
                            alt: "ページの先頭に戻る",
                            width: "80",
                            height: "80",
                            id: "bt_top",
                            border: "0"
                        })
                    ])
                ])
            ], 64));
        };
    }
});
